import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface AvailableCriteriaItem {
  categoryFieldId: number;
  categoryName: string;
}

interface AvailableCriteriaState {
  items: AvailableCriteriaItem[];
}

const initialState: AvailableCriteriaState = {
  items: [],
};

const optimizedSortSlice = createSlice({
  name: 'availableCriteria',
  initialState,
  reducers: {
    setAvailableCriteria(
      state,
      action: PayloadAction<AvailableCriteriaItem[]>
    ) {
      state.items = action.payload;
    },
    clearAvailableCriteria(state) {
      state.items = [];
    },
  },
});

export const {setAvailableCriteria, clearAvailableCriteria} =
  optimizedSortSlice.actions;
export default optimizedSortSlice.reducer;
